import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-espaco-aluno-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './espaco-aluno-layout.component.html',
  styleUrl: './espaco-aluno-layout.component.scss'
})
export class EspacoAlunoLayoutComponent {

}
